import React from 'react';
import { AppThemeProvider } from './theme/ThemeContext';
import { BennieClientProvider } from './app/providers/BennieClientProvider';
import { createBennieServices } from './app/createServices';
import { PrdApp } from './router/PrdApp';
import { AppAuthGate } from './app/auth/AppAuthGate';
import { TosGate } from './components/legal/TosGate';
import i18n from './i18n';

function App() {
  const bennieServices = React.useMemo(() => createBennieServices(), []);

  // WI-04: keep document.documentElement.lang synced with the active i18n language.
  // Pre-React the static <html lang="en"> attribute on index.html applies; this effect
  // overrides it once i18n is ready so screen readers / search crawlers / browser
  // font-fallback heuristics see the correct lang (WCAG 2.1 SC 3.1.1 "Language of Page").
  // The HTML static lang="en" is preserved as the pre-hydration default; this effect
  // is the runtime authority. Fixes a fr-locale defect surfaced by zh-CN audit.
  React.useEffect(() => {
    const apply = () => {
      const code = i18n.resolvedLanguage ?? i18n.language ?? 'en';
      if (typeof document !== 'undefined' && document.documentElement) {
        document.documentElement.lang = code;
      }
    };
    apply(); // initial sync (i18n is already initialized in main.tsx before App mounts)
    i18n.on('languageChanged', apply);
    return () => {
      i18n.off('languageChanged', apply);
    };
  }, []);

  return (
    <AppThemeProvider>
      <AppAuthGate>
        <TosGate>
          <BennieClientProvider value={bennieServices}>
            <PrdApp />
          </BennieClientProvider>
        </TosGate>
      </AppAuthGate>
    </AppThemeProvider>
  );
}

export default App;
